<div class="input" [ngClass]="{ 'input--modern': appearance === 'modern' }">
  <label class="input-label" [for]="inputId" [ngClass]="{ 'input-label--modern': appearance === 'modern' }">
    {{ label }}
    <span *ngIf="required && appearance === 'modern'" class="input-required"></span>
  </label>

  <ng-container *ngIf="inputType !== 'textarea'">
    <input
      class="input-edit"
      [ngClass]="{
        'input-edit--modern': appearance === 'modern',
        'input-edit--invalid': appearance === 'modern' && hasErrorState,
        'input-parameter': isParameter,
        'input-product': isProduct,
        combo: combo,
        'text-uppercase': uppercase || inputMask === 'CPF_CNPJ'
      }"
      *ngIf="!inputMask && inputType !== 'datetime-local'"
      [type]="inputType"
      [id]="inputId"
      [placeholder]="placeholder"
      [readonly]="readonly"
      [required]="required"
      [attr.aria-required]="required ? true : null"
      [attr.aria-invalid]="hasErrorState ? true : null"
      [attr.aria-describedby]="describedBy"
      [ngModel]="value"
      [disabled]="disabled"
      (ngModelChange)="value = uppercase ? $event.toUpperCase() : $event; onChange(value)"
      type="date"
    />

    <input
      class="input-edit"
      [ngClass]="{ 'input-edit--modern': appearance === 'modern', 'input-edit--invalid': appearance === 'modern' && hasErrorState, 'input-product': isProduct, combo: combo }"
      *ngIf="inputMask && currencyMask "
      type="text"
      [id]="inputId"
      [placeholder]="placeholder"
      [readonly]="readonly"
      [required]="required"
      [attr.aria-required]="required ? true : null"
      [attr.aria-invalid]="hasErrorState ? true : null"
      [attr.aria-describedby]="describedBy"
      [ngModel]="value"
      (ngModelChange)="value = $event; onChange($event)"
      (keyup)="transformCurrency()"
    />

    <input
      class="input-edit"
      [ngClass]="{
        'input-edit--modern': appearance === 'modern',
        'input-edit--invalid': appearance === 'modern' && hasErrorState,
        'input-product': isProduct,
        combo: combo,
        'text-uppercase': uppercase || inputMask === 'CPF_CNPJ'
      }"
      *ngIf="inputMask && !currencyMask && inputMask !== 'CPF_CNPJ'"
      [mask]="inputMask"
      [dropSpecialCharacters]="dropSpecial"
      [type]="inputType"
      [id]="inputId"
      [placeholder]="placeholder"
      [readonly]="readonly"
      [required]="required"
      [attr.aria-required]="required ? true : null"
      [attr.aria-invalid]="hasErrorState ? true : null"
      [attr.aria-describedby]="describedBy"
      [ngModel]="value"
      [disabled]="disabled"
      (ngModelChange)="value = uppercase ? $event.toUpperCase() : $event; onChange(value)"
    />

    <!-- Input customizado para CPF_CNPJ (aceita alfanumérico) -->
    <input
      class="input-edit text-uppercase"
      [ngClass]="{ 'input-edit--modern': appearance === 'modern', 'input-edit--invalid': appearance === 'modern' && hasErrorState, 'input-product': isProduct, combo: combo }"
      *ngIf="inputMask === 'CPF_CNPJ'"
      [type]="inputType"
      [id]="inputId"
      [placeholder]="placeholder"
      [readonly]="readonly"
      [required]="required"
      [attr.aria-required]="required ? true : null"
      [attr.aria-invalid]="hasErrorState ? true : null"
      [attr.aria-describedby]="describedBy"
      [ngModel]="value"
      [disabled]="disabled"
      (input)="onCpfCnpjInput($event)"
      maxlength="18"
    />

    <input
      class="input-edit"
      [ngClass]="{ 'input-edit--modern': appearance === 'modern', 'input-edit--invalid': appearance === 'modern' && hasErrorState }"
      *ngIf="!inputMask && inputType === 'datetime-local'"
      [type]="inputType"
      [id]="inputId"
      [placeholder]="placeholder"
      [readonly]="readonly"
      [required]="required"
      [attr.aria-required]="required ? true : null"
      [attr.aria-invalid]="hasErrorState ? true : null"
      [attr.aria-describedby]="describedBy"
      [ngModel]="value"
      [disabled]="disabled"
      (ngModelChange)="value = $event; onChange($event)"
    />
 </ng-container>

  <textarea
    class="input-textarea"
    [ngClass]="{
      'input-textarea--modern': appearance === 'modern',
      'input-textarea--invalid': appearance === 'modern' && hasErrorState,
      'input-parameter': isParameter,
      'input-product': isProduct,
      combo: combo
    }"
    *ngIf="inputType === 'textarea'"
    [id]="inputId"
    [placeholder]="placeholder"
    [readonly]="readonly"
    [required]="required"
    [attr.aria-required]="required ? true : null"
    [attr.aria-invalid]="hasErrorState ? true : null"
    [attr.aria-describedby]="describedBy"
    [(ngModel)]="value"
    [disabled]="disabled"
    (ngModelChange)="onChange($event)"
    [maxlength]="500"
    [rows]="rows"></textarea>

  <div *ngIf="appearance === 'modern'" class="input-meta" aria-live="polite">
    <span *ngIf="!hasErrorState && hint" [id]="hintId" class="input-hint">{{ hint }}</span>
    <span *ngIf="hasErrorState" [id]="errorId" class="input-error" role="alert">{{ currentErrorMessage }}</span>
  </div>

</div>
